<div class="databox">
  <app-fa-icon [config]="icon()" />
  <span>{{ lives() }}</span>
</div>
